import React, { useState, useRef } from "react";
import {
  Typography,
  Button,
  Paper,
  Container,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Sidebar from "../user/sidebar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    width: "400px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",

  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  profileImage: {
    width: "100px",
    height: "100px",
    margin: "0 auto",
    display: "block",
    cursor: "pointer",
  },
  hiddenFileInput: {
    display: "none",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  buttonSpacing: {
    margin: theme.spacing(2),
  },
  centerText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

/**
 * Profile Picture Upload Enhancement
 *
 * This update enhances the profile picture upload feature with the following improvements:
 *
 * 1. Added an "Upload" button: A dedicated "Upload" button is now displayed below the profile icon, making it more intuitive for users to initiate the upload process.
 *
 * 2. Dynamic Button Display:
 *    - When users select a profile picture, the "Remove" and "Update" buttons will replace the "Upload" button temporarily, allowing users to either remove the selected picture or update it.
 *    - After removing or updating the picture, the "Upload" button will reappear.
 *
 * 3. "Uploading..." Message:
 *    - During the upload process, an "Uploading..." message and a progress indicator are displayed to provide feedback to the user.
 *
 * These enhancements improve the user experience and provide clear visual cues for profile picture management. Feel free to add additional features or modify existing features @levy-web
 */

/**
 * Improved Centering:
 * - Set a minimum height for the paper container to ensure vertical centering.
 * - Added a centerText class for horizontal and vertical centering of "Profile Picture" text.
 */

function Profile() {
  const classes = useStyles();
  const [profilePicture, setProfilePicture] = useState(null);
  const [showButtons, setShowButtons] = useState(false);
  const [uploading, setUploading] = useState(false); // New state for tracking uploading state
  const fileInputRef = useRef(null);
  const loggeinUser = useSelector((state) => state.user.buyer);
  console.log(loggeinUser)


  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
      <Sidebar />

      <div className="p-4 w-full rounded-lg h-[calc(100vh_-_150px)] shadow-md mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4">

      <div className="p-4 w-full rounded-lg shadow-md mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="image-container" style={{ width: '200px', height: '200px', overflow: 'hidden' }}>
          <img src={loggeinUser?.profile_pic_url} alt="Profile" style={{ width: '100%', height: 'auto' }} />
        </div>
          <div className="profile-details">
            <h2>{`${loggeinUser?.firstName} ${loggeinUser?.middleName} ${loggeinUser?.surname}`}</h2>
            <p>Email: {loggeinUser?.email}</p>
            <p>Phone Number: {loggeinUser?.phone}</p>
            <div className="p-4 w-full rounded-lg shadow-md mx-auto"> 
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">        
                <div className="" style={{ width: '200px', height: '200px', overflow: 'hidden' }}>
                  <img src={loggeinUser?.id_front_url} alt="ID Front" />
                </div>
                <div className="" style={{ width: '200px', height: '200px', overflow: 'hidden' }}>
                  <img src={loggeinUser?.id_back_url} alt="ID Back" />
                </div>
            </div>
          </div>
          </div>
          
        </div>
        </div>


        

      </div>
      </div>

    </Container>
  );
}

export default Profile;
